import {
  createError,
  defineNuxtRouteMiddleware,
  useRequestHeaders,
  useRuntimeConfig,
} from '#imports'

import { HttpHeader } from '@backmarket/http-api'

const WEBVIEW_USER_AGENT_TOKEN = 'bm-mobile-app-webview'

export function isWebviewUserAgent(userAgent: string | undefined): boolean {
  return !!userAgent?.includes(WEBVIEW_USER_AGENT_TOKEN)
}

// Gates routes that should ONLY be reachable from inside the Back Market iOS
// webview. Anyone else (desktop browser, search-engine crawler, mobile web)
// gets a 404 — same response shape as a missing route, so the route is
// effectively invisible from outside the app.
//
// The gate is bypassed when:
// - running locally with `pnpm dev` (`import.meta.dev`)
// - the `DEV_OUTLET_WEB_ACCESS_ENABLED` runtime config flag is true. Set via
//   `NUXT_PUBLIC_DEV_OUTLET_WEB_ACCESS_ENABLED=true` on DSE/preview/staging
//   so the team can browse outlet pages from a regular browser. MUST stay
//   false in production.
export default defineNuxtRouteMiddleware(() => {
  if (import.meta.dev) return

  const { DEV_OUTLET_WEB_ACCESS_ENABLED } = useRuntimeConfig().public
  if (DEV_OUTLET_WEB_ACCESS_ENABLED) return

  const headers = useRequestHeaders([HttpHeader.USER_AGENT])
  const userAgent =
    headers[HttpHeader.USER_AGENT] ??
    (typeof window !== 'undefined' ? window.navigator?.userAgent : '')

  if (!isWebviewUserAgent(userAgent)) {
    throw createError({ statusCode: 404, statusMessage: 'Not Found' })
  }
})
